var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{staticClass:"main-appbar",attrs:{"flat":"","color":"transparent"}},[_c('app-bar-nav-icon'),_c('v-toolbar-title',{staticClass:"breadcrumbs d-flex align-center"},[_c('v-icon',{staticClass:"text-light-blue"},[_vm._v(_vm._s(_vm.icons.arrowLeft))]),_c('router-link',{staticClass:"text-decoration--none",attrs:{"to":{
          name: 'onboarding-questions'
        }}},[_vm._v("Onboarding Questions ")])],1)],1),_c('question-form',{on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }